<template>
  <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
  <label class="confetti-radio-container" :class="classes">
    <input
      class="confetti-radio-input"
      type="radio"
      :checked="checked"
      :disabled="disabled"
      :name="name"
      :value="value"
      @change="$emit('change', value)"
    />

    <div class="confetti-radio-checkmark-container">
      <div class="confetti-radio-checkmark"></div>
    </div>
    <div class="confetti-radio-text-container">
      <span class="confetti-radio-text">{{ text }}</span>
      <span
        v-if="shouldShowReveal"
        class="confetti-radio-reveal"
        data-testid="confetti-radio-button-reveal"
      >
        {{ reveal }}
      </span>
    </div>
  </label>
</template>

<script>
export default {
  name: "ConfettiRadioButton",
  props: {
    checked: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    inline: {
      type: Boolean,
    },
    name: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    reveal: {
      type: String,
      default: "",
    },
    shouldAlwaysShowReveal: {
      type: Boolean,
    },
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    classes() {
      return this.inline ? "inline" : "";
    },
    shouldShowReveal() {
      if (this.shouldAlwaysShowReveal) {
        return true;
      }

      const shouldShow = this.checked && this.reveal;

      return shouldShow;
    },
  },
};
</script>
